export class SearchResources200ResponseTablesInnerTablesInner {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "name",
            "baseName": "name",
            "type": "string",
            "format": ""
        },
        {
            "name": "schemaName",
            "baseName": "schemaName",
            "type": "string",
            "format": ""
        },
        {
            "name": "databaseName",
            "baseName": "databaseName",
            "type": "string",
            "format": ""
        },
        {
            "name": "rowsCount",
            "baseName": "rowsCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "columns",
            "baseName": "columns",
            "type": "Array<SearchResources200ResponseTablesInnerTablesInnerColumnsInner>",
            "format": ""
        },
        {
            "name": "explanation",
            "baseName": "explanation",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SearchResources200ResponseTablesInnerTablesInner.attributeTypeMap;
    }
    constructor() {
    }
}
